import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import "../training.css"
import { useParams } from 'react-router-dom';
import { GoPlay } from "react-icons/go";
import { BiSkipNextCircle } from "react-icons/bi";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import McqQuiz from "./McqQuiz";

const TrainingField = () => {
  const [resources , setResources] = useState([]);
  const [trainingData , setTrainingData] = useState();
  const [selected , setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [open , setOpen] = useState(false)
  
  console.log(selected,"selectedselected")


const fetchVideos = useCallback(async () => {
  try {
    const res = await api.get(`${API_BASE_URL}training-resources/training/${id}`);

    const videos = res.data?.videosWithUnlocks;

    setResources(videos);
    setTrainingData(res.data?.training);

    setSelected((prev) => {
      if (prev) return prev;
      return videos?.find(v => v.unlocked) || null;
    });

  } catch (err) {
    console.error(err);
  }
}, [id]); // ✅ only id

useEffect(() => {
  fetchVideos();
}, [fetchVideos]); // ✅ no warning   
    const handleComplete = async (videoId) => {
    try {
      setLoading(true);
     const res = await api.post(`${API_BASE_URL}training-progress/complete`, {videoId });
      const nextVideoId = res.data.nextVideoId;
      setSelected(res.data);
      await fetchVideos();
        if (nextVideoId) {
        const nextVideo = resources.find(v => v.id === nextVideoId);
        console.log(nextVideo, "nextVideo");
        if (nextVideo) setSelected(nextVideo);
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
const totalVideos = resources.length;
const watchedCount = resources.filter(p => p.completed).length;
const progressPercentage = totalVideos === 0 ? 0 : Math.round((watchedCount / totalVideos) * 100);

// const scrollToTop = (video) => {
//   if (video.completed || video.unlocked) {
//     window.scrollTo({
//       top: 120,
//       behavior: 'smooth', // smooth scroll
//     });
//     }
//     else return
//   };
// const scrollToComplete =() => {
// window.scrollTo({
//       top: 120,
//       behavior: 'smooth', // smooth scroll
//     });
//     }
// const scrollToQuiz =() => {
//    const bottom = document.documentElement.scrollHeight;
// window.scrollTo({
//       top: bottom,
//       behavior: 'smooth', // smooth scroll
//     });
//     }
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}


  return (
    <div className="">
      <div className="field-header">
         <div className="fieldImg"></div>
          <div className="field-h">
            <h2>{trainingData?.name}</h2>
            <div className="completed">
                <span>{progressPercentage}% &nbsp; Completed</span>
                <div class="field-container">
                    <div class="field-bar" style={{ width: `${progressPercentage}%` }}></div>
                 </div>
            </div>
          </div>
      </div>
        {/* Course Overview */}
        <div className="courseFlex">
        <div className="courseLayout">
            <div className="courseOverview">
              <div className="trainingCover" style={{backgroundImage:`url(${FILES_URL}${trainingData?.cover?.url})`}}></div>
              <div className="flex justify-between gap-4">
              <div className="w-[90%]">
                <h4>Course Overview</h4>
                <p><MyComponent htmlContent={trainingData?.overview}/>      
                </p>
                </div>
                <button disabled={progressPercentage < 100} onClick={() => {setOpen(true);
               }} 
               className={progressPercentage < 100 ? "quizNoActive mt-8" : "btn-Quiz mt-8"}>Start Quiz</button>
               </div>
            </div>
            <div className="listPlayer"> 
                  {selected ? (
            <div className="videoFrame">
            {/* <h3 className="videoName">{selected.title}</h3> */}
            <iframe
              key={selected.id}
              src={selected.url}
              style={{ border: 0, width: "100%", height: "520px", borderRadius: "12px", marginBottom: "20px", alignItems: "center" }}
              allowFullScreen
              allow="encrypted-media"
              title="VdoCipher Video"> </iframe>
            {loading && <div>Saving progress...</div>}
           {!selected.completed ? <button className="markComplete"
            onClick={() => {handleComplete(selected.id)
              // scrollToComplete();
            }}>Mark as Complete 
            <IoCheckmarkDoneCircleOutline className="doneImgHover"/></button> : null}
          </div>
        ) : (
          <div style={{marginBottom: "20px"}}>
            {/* <h3>No video selected</h3>
            <p>Select an unlocked video to start watching.</p> */}
          </div>
        )}
            <div className="courseCards">
              {resources.map(video =>
            <div className={video.id === selected?.id ? "course-view activeList" : "course-view inActiveList"} key={video.id}
            style={{ cursor: video.unlocked ? 'pointer' : video.completed ? 'pointer' : 'not-allowed'}}
            onClick={() => {video.unlocked && setSelected(video)
            // scrollToTop(video);
            }}>
            <div className="playImg"></div>
            {/* {video.order} */}
                <p>{video.title} </p>
                
                {video.completed ? <IoCheckmarkDoneCircleOutline className="doneImg" style={{ color: "rgb(4, 202, 4)" }}/>
                 : video.unlocked ? <GoPlay className="doneImg" style={{ color: "#573995" }}/> 
                 : <BiSkipNextCircle className="doneImg" style={{ color: "#4a4a4aae" }}/>}
                {/* <button onClick={() => handleComplete(video.id)}>Mark as Complete</button> */}
              </div>
          )}
          </div>
          </div>
        </div>
        </div>
      {open && (
        <div className="quiz-overlay" onClick={() => setOpen(false)}>
          <div className="quiz-popup" onClick={e => e.stopPropagation()}>
            <button className="quiz-close-btn" onClick={() => setOpen(false)}>&#x2715;</button>
            <McqQuiz questions={trainingData.mcqTraining} trainingId={trainingData.id}/>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingField;
